import {isSelectedElementOptimized} from '@packages/systems/optimization/utils';
import {abilityFeature} from '../abilityFeature';

export const selectedElementOptimized = abilityFeature({
  key: 'selectedElementOptimized',
  isValid(state, expected) {
    const isOptimized = state.DesignerStore
      ? isSelectedElementOptimized(state)
      : false;
    return isOptimized === expected;
  },
});
